export default "__VITE_ASSET__BVKbGIuQ__"